/**
 * Skogstad Sport – hero-karusell
 * ---------------------------------------------------------------------------
 * Seksjonen: sections/skogstad-hero-karusell.liquid
 * Stilene:   assets/skogstad-hero-karusell.css
 *
 * Skriptet gjør nøyaktig to ting: bestemmer hvilken flate som har klassen
 * `er-aktiv`, og sier fra om klokka går (`data-gaar`). Alt det synlige –
 * krysstoningen, at de skjulte flatene ikke kan tabuleres til, streken som
 * fylles opp – ligger i CSS. Derfor ser seksjonen riktig ut også hvis denne
 * fila aldri lastes: Liquid har allerede satt `er-aktiv` på flate én, og
 * kontrollene er skjult til vi setter `data-klar`.
 *
 * HVORFOR IKKE ET BIBLIOTEK
 * Karusellen har to flater som krysstoner. Swiper, Flickity og Splide veier
 * 30–100 kB for å løse problemer vi ikke har – uendelig løkke, flere synlige
 * elementer, treghetsscroll, virtuelle slides. Her ville de bare lagt et lag
 * til mellom et klikk og en klasse.
 *
 * ---------------------------------------------------------------------------
 * KLOKKA ER requestAnimationFrame, IKKE setInterval
 *
 * Fordi det finnes to klokker som må vise det samme: skriptets, som bytter
 * flate, og CSS-animasjonen som fyller opp streken under. Med setInterval kan
 * de bare stoppes ved å nullstilles – trykker kunden pause etter fem av sju
 * sekunder og starter igjen, begynner timeren på nytt fra null mens streken
 * fortsetter der den sto. Da lyver streken.
 *
 * Her akkumuleres forløpt tid i stedet, og begge klokkene fryses på samme
 * signal (`data-gaar`) og fortsetter fra samme sted. En bonus er at rAF ikke
 * kjører i en skjult fane i det hele tatt.
 *
 * ---------------------------------------------------------------------------
 * NÅR ROTASJONEN STOPPER – OG HVORFOR IKKE PÅ HOVER

 * WCAG 2.2.2 krever at innhold som beveger seg av seg selv i mer enn fem
 * sekunder kan stoppes. Pauseknappen dekker kravet. Utover det stopper den
 * bare når det er riktig:
 *
 *   tastaturfokus inni           kunden navigerer i flaten
 *   musepekeren over KONTROLLENE kunden sikter på en prikk
 *   utenfor visningsflaten       kunden har scrollet forbi
 *   fanen ikke synlig            kunden er et annet sted
 *
 * Den STOPPER IKKE når musepekeren er over selve bildet, og det er et bevisst
 * valg vi har tatt om igjen: heroen er full bredde og dekker hele toppen av
 * skjermen, så en musepeker som bare ligger i ro der – som den gjør hos de
 * fleste – ville frosset karusellen for godt. Symptomet er at den «aldri
 * slider», og årsaken er usynlig. Hover over de 150 pikslene med kontroller
 * er derimot et signal om at kunden faktisk sikter på noe.
 *
 * `prefers-reduced-motion` stopper heller ikke rotasjonen, den fjerner
 * krysstoningen (i CSS) så flaten bytter momentant. Samme linje som Shopifys
 * eget Dawn: kravet er at bevegelsen kan stoppes, ikke at innholdet står
 * stille. En innstilling dypt inne i operativsystemet skal ikke slå av en
 * kampanje uten at noen skjønner hvorfor.
 *
 * Grunnene holdes i et objekt og ikke i én boolsk verdi. Med ett flagg ville
 * «mus ut av kontrollene» startet klokka igjen selv om fanen var skjult,
 * fordi den siste hendelsen alltid ville vunnet.
 */
(function () {
  'use strict';

  var VELGER_ROT = '[data-sk-hero-karusell]';
  var VELGER_FLATE = '[data-sk-hero-flate]';
  var VELGER_PRIKK = '[data-sk-hero-prikk]';
  var VELGER_PAUSE = '[data-sk-hero-pause]';
  var VELGER_SPOR = '[data-sk-hero-spor]';
  var VELGER_KONTROLLER = '[data-sk-hero-kontroller]';

  // Under dette regnes bevegelsen som et trykk, ikke et dra. 45 px er omtrent
  // en halv tommelbredde – nok til at en skjelven finger på en lenke ikke
  // bytter flate ved et uhell.
  var DRA_TERSKEL = 45;

  function Karusell(rot) {
    this.rot = rot;
    this.flater = Array.prototype.slice.call(rot.querySelectorAll(VELGER_FLATE));
    this.prikker = Array.prototype.slice.call(rot.querySelectorAll(VELGER_PRIKK));
    this.pauseKnapp = rot.querySelector(VELGER_PAUSE);
    this.kontroller = rot.querySelector(VELGER_KONTROLLER);
    this.spor = rot.querySelector(VELGER_SPOR);

    if (this.flater.length < 2) {
      // Én flate er ikke en karusell. Vi setter ikke engang data-klar, så
      // kontrollene forblir skjulte og seksjonen oppfører seg som en vanlig
      // hero.
      return;
    }

    this.indeks = 0;
    this.auto = rot.getAttribute('data-auto') === 'true';
    this.intervall = parseInt(rot.getAttribute('data-intervall'), 10) || 7000;

    this.raf = null;
    this.forlopt = 0;
    this.sist = null;
    this.gaar = false;
    this.stoppetAvBruker = false;
    this.grunner = { pekerPaKontroller: false, fokus: false, utenfor: false, fane: false };

    this.draStart = null;
    this.draFlyttet = false;

    this.bindHendelser();

    rot.setAttribute('data-klar', 'true');
    this.oppdaterPauseknapp();
    this.vurderKlokke();
  }

  Karusell.prototype.bindHendelser = function () {
    var meg = this;

    this.prikker.forEach(function (prikk) {
      prikk.addEventListener('click', function () {
        var mal = parseInt(prikk.getAttribute('data-indeks'), 10) || 0;
        meg.gaTil(mal, true);
      });
    });

    if (this.pauseKnapp) {
      this.pauseKnapp.addEventListener('click', function () {
        meg.stoppetAvBruker = !meg.stoppetAvBruker;
        meg.oppdaterPauseknapp();
        meg.vurderKlokke();
      });
    }

    // Bare kontrollene, ikke hele flaten. Se merknaden øverst i fila – dette
    // er forskjellen på en karusell som går og en som ser ut som den henger.
    if (this.kontroller) {
      this.kontroller.addEventListener('mouseenter', function () {
        meg.settGrunn('pekerPaKontroller', true);
      });
      this.kontroller.addEventListener('mouseleave', function () {
        meg.settGrunn('pekerPaKontroller', false);
      });
    }

    // focusin/focusout og ikke focus/blur: de to siste bobler ikke, og fokuset
    // havner på en lenke INNE i flaten, ikke på flaten selv.
    this.rot.addEventListener('focusin', function () {
      meg.settGrunn('fokus', true);
    });
    this.rot.addEventListener('focusout', function () {
      meg.settGrunn('fokus', false);
    });

    document.addEventListener('visibilitychange', function () {
      meg.settGrunn('fane', document.hidden);
    });

    if ('IntersectionObserver' in window) {
      var kikker = new IntersectionObserver(
        function (poster) {
          meg.settGrunn('utenfor', !poster[poster.length - 1].isIntersecting);
        },
        { threshold: 0 }
      );
      kikker.observe(this.rot);
    }

    this.bindDra();
    this.bindEditor();
  };

  /**
   * Sveip på mobil.
   *
   * Pointer-hendelser og ikke touch: samme kode dekker finger, penn og mus.
   *
   * Det vanskelige er ikke sveipen, det er klikket etterpå. Drar man fra en
   * knapp i tekstblokka, sender nettleseren fortsatt et click når fingeren
   * slippes – kunden ville byttet flate OG blitt sendt til kolleksjonen.
   * Derfor spises det ene klikket som kommer rett etter en sveip, i
   * capture-fasen før det når lenken.
   */
  Karusell.prototype.bindDra = function () {
    if (!this.spor || !window.PointerEvent) return;
    var meg = this;

    this.spor.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      meg.draStart = { x: e.clientX, y: e.clientY };
      meg.draFlyttet = false;
    });

    this.spor.addEventListener('pointerup', function (e) {
      if (!meg.draStart) return;
      var dx = e.clientX - meg.draStart.x;
      var dy = e.clientY - meg.draStart.y;
      meg.draStart = null;

      // Loddrett bevegelse er scrolling, ikke en sveip. Uten denne ville en
      // skrå scroll nedover byttet flate.
      if (Math.abs(dx) < DRA_TERSKEL || Math.abs(dx) < Math.abs(dy)) return;

      meg.draFlyttet = true;
      meg.gaTil(meg.indeks + (dx < 0 ? 1 : -1), true);
    });

    this.spor.addEventListener('pointercancel', function () {
      meg.draStart = null;
    });

    this.spor.addEventListener(
      'click',
      function (e) {
        if (!meg.draFlyttet) return;
        meg.draFlyttet = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  };

  /**
   * Temaeditoren. Velger redaktøren en flate i panelet til venstre, skal den
   * flaten vises – ellers redigerer hun noe hun ikke ser. Klokka står stille
   * så lenge en flate er valgt, av samme grunn.
   */
  Karusell.prototype.bindEditor = function () {
    if (!window.Shopify || !window.Shopify.designMode) return;
    var meg = this;

    document.addEventListener('shopify:block:select', function (e) {
      if (!meg.rot.contains(e.target)) return;
      var nr = meg.flater.indexOf(e.target);
      if (nr > -1) meg.gaTil(nr, true);
      meg.settGrunn('fokus', true);
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (!meg.rot.contains(e.target)) return;
      meg.settGrunn('fokus', false);
    });
  };

  Karusell.prototype.settGrunn = function (navn, verdi) {
    if (this.grunner[navn] === verdi) return;
    this.grunner[navn] = verdi;
    this.vurderKlokke();
  };

  Karusell.prototype.kanKjore = function () {
    if (!this.auto) return false;
    if (this.stoppetAvBruker) return false;
    for (var navn in this.grunner) {
      if (this.grunner[navn]) return false;
    }
    return true;
  };

  /**
   * Start eller stopp klokka, og fortell CSS hva som gjelder.
   *
   * `data-gaar` er det eneste signalet streken under prikken lytter på:
   * står den på «false», settes animasjonen i pause der den er – ikke
   * tilbake til null. Fordi skriptet fryser `forlopt` i samme øyeblikk,
   * viser streken hele tiden hvor lenge det faktisk er igjen.
   */
  Karusell.prototype.vurderKlokke = function () {
    var kjorer = this.kanKjore();
    this.rot.setAttribute('data-gaar', kjorer ? 'true' : 'false');

    if (kjorer === this.gaar) return;
    this.gaar = kjorer;

    if (kjorer) {
      var meg = this;
      // `sist = null` gjør at pausen ikke telles med: første bilde etter at
      // klokka startet igjen bidrar med null, ikke med de tolv sekundene
      // kunden brukte på å lese.
      this.sist = null;
      var tikk = function (na) {
        if (!meg.gaar) return;
        if (meg.sist !== null) meg.forlopt += na - meg.sist;
        meg.sist = na;
        if (meg.forlopt >= meg.intervall) {
          meg.forlopt = 0;
          meg.gaTil(meg.indeks + 1, false);
        }
        meg.raf = window.requestAnimationFrame(tikk);
      };
      this.raf = window.requestAnimationFrame(tikk);
    } else if (this.raf) {
      window.cancelAnimationFrame(this.raf);
      this.raf = null;
      this.sist = null;
    }

    // aria-live er «off» mens flaten bytter av seg selv: en skjermleser som
    // leste opp hele heroen hvert sjuende sekund ville gjort siden ubrukelig.
    // Står rotasjonen stille, er hvert bytte noe kunden har bedt om – og da
    // skal det annonseres.
    if (this.spor) {
      this.spor.setAttribute('aria-live', kjorer ? 'off' : 'polite');
    }
  };

  Karusell.prototype.gaTil = function (mal, brukerstyrt) {
    var antall = this.flater.length;
    var nr = ((mal % antall) + antall) % antall;

    // Klikk på prikken til flaten som allerede vises er ingenting. Nullstilte
    // vi klokka her, ville streken under fortsatt telt videre fra der den sto –
    // den restartes bare når `er-aktiv` faktisk flytter seg – og de to ville
    // vist hver sin gjenstående tid.
    if (nr === this.indeks) return;

    // Klikk eller sveip til en annen flate er kunden som tar over. Da skal den
    // ikke rives bort igjen etter to sekunder fordi det var det som var igjen
    // av intervallet – klokka begynner på nytt, i takt med streken, som
    // restartes av at klassen flytter seg rett under her.
    if (brukerstyrt) {
      this.forlopt = 0;
      this.sist = null;
    }

    this.flater.forEach(function (flate, i) {
      flate.classList.toggle('er-aktiv', i === nr);
    });

    this.prikker.forEach(function (prikk, i) {
      prikk.classList.toggle('er-aktiv', i === nr);
      if (i === nr) {
        prikk.setAttribute('aria-current', 'true');
      } else {
        prikk.removeAttribute('aria-current');
      }
    });

    this.indeks = nr;
  };

  Karusell.prototype.oppdaterPauseknapp = function () {
    this.rot.setAttribute('data-pauset', this.stoppetAvBruker ? 'true' : 'false');
    if (!this.pauseKnapp) return;

    // Knappen er merket med det den GJØR ved neste trykk, ikke med tilstanden
    // den står i. Strengene er temaets egne – de samme som Impulses eget
    // bildespill bruker, så de to knappene aldri sier hver sin ting.
    var etikett = this.pauseKnapp.getAttribute(
      this.stoppetAvBruker ? 'data-etikett-spill' : 'data-etikett-pause'
    );
    // Bare navnet endres, ikke aria-pressed i tillegg. En knapp som både
    // heter «Start bildespill» OG melder «ikke trykket» sier det samme to
    // ganger, med motsatt fortegn.
    if (etikett) this.pauseKnapp.setAttribute('aria-label', etikett);
  };

  function start(omrade) {
    var rot = omrade || document;
    var alle = rot.querySelectorAll(VELGER_ROT);
    Array.prototype.forEach.call(alle, function (el) {
      if (el.hasAttribute('data-klar')) return;
      new Karusell(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
    });
  } else {
    start();
  }

  // Temaeditoren bytter ut seksjonens HTML uten å laste siden på nytt.
  document.addEventListener('shopify:section:load', function (e) {
    start(e.target);
  });
})();
